import { useQuery } from '@tanstack/react-query';
import { API } from '@/services/api.service';

/**
 * Treasury municipalities as Select options („013 Novi Beograd"), searchable
 * by code or name. The list never changes while the page is open.
 */
export const useMunicipalityOptions = (enabled = true) => {
  const { data } = useQuery({
    queryKey: ['tax-municipalities'],
    queryFn: API.taxReturns.getMunicipalities,
    staleTime: Infinity,
    enabled,
  });
  return (data || []).map((m) => ({ value: m.code, label: `${m.code} ${m.name}` }));
};

export const municipalitySelectProps = {
  showSearch: true,
  optionFilterProp: 'label',
  popupMatchSelectWidth: false,
};
